<!--begin::Scrolltop-->
<div id="kt_scrolltop" class="scrolltop">
  <span [inlineSVG]="'./assets/media/svg/icons/Navigation/Up-2.svg'" cacheSVG="true" class="svg-icon"></span>
</div>
<!--end::Scrolltop-->